<div class="trend-chart">
  <!--
    ECharts renders into this host element imperatively (see ngAfterViewInit).
    Kept in the DOM unconditionally rather than behind an *ngIf so the
    ViewChild is always resolvable; the empty state overlays it instead.
  -->
  <div #chartHost class="trend-chart-canvas" [style.height.px]="height" [class.trend-chart-hidden]="!hasData"
    [style.touch-action]="ownsTouchGestures ? 'none' : null"></div>
  <div *ngIf="!hasData" class="trend-chart-empty" [style.min-height.px]="height">
    {{ noDataText }}
  </div>
</div>
